/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';

import useIdentity from 'hooks/identity/useIdentity';
import useApi from 'api/hooks/useApi';
import { createTwoFactorViaEmail } from 'api/session/twoFactorSubmit';

import Button from 'components/Button';


const TwoFactorEmail = ({ onComplete }) => {
  const api = useApi(createTwoFactorViaEmail, 'Create2FAEmail', {
    successMessage: 'You\'re setup to receive verification codes via email.',
    onComplete
  });
  const identity = useIdentity();

  return (
    <div>
      <div style={{lineHeight: '1.5'}}>
        When you login to your Viewpost account in the future, we'll send a verification code
        to <strong>{identity.email}</strong> to make sure its you.
      </div>
      <div style={{textAlign: 'right', marginTop: '20px'}}>
        <Button onClick={() => api.call({})}
          isProcessing={api.isLoading()}
          isDisabled={api.isLoading()}>
          Enable Verification Via Email
        </Button>
      </div>
    </div>
  );
};

export default TwoFactorEmail;